<template>
  <div class="tab-list">
    <div
    @click="slideTo(item)"
      :class="[
        'tab-item',
        currentCategoryObj.id == item.category_id ? 'tab-item-active' : '',
      ]"
      v-for="(item, index) in category_list"
    >
      {{ item.category_name }}
    </div>
  </div>
</template>
<script setup>
import { traceEventClick } from "@common/utils";

import { defineProps } from "vue";
const emit = defineEmits()

const props = defineProps({
  currentCategoryObj: {
    type: Object,
    default: () => {},
  },
  category_list:{
    type:Array,
    default: () => []
  }
});
const slideTo = (item)=>{
  traceEventClick({
    content:item.category_name || '',
    button_name:'车系选择',
    page:'车型选择页',
  })  
  emit('slideTo',item.category_id)
}
</script>

<style lang="scss" scoped>
.tab-list {
  display: flex;
  align-items: center;
  padding-left: 20px;
  .tab-item {
    height: 50px;
    font-size: 16px;
    line-height: 50px;
    color: #999dae;
    font-family: $font-family-base;
    font-weight: 500;
    padding:0 20px;
  }
  .tab-item-active {
    color: #050b27;
  }
}
</style>
